export default "__VITE_ASSET__DfMcI_Ug__"